import { BreadcrumbLabel } from '@app/navigation/BreadcrumbLabel';

import { useGetInquiryHeaderQuery } from '../api/inquiry-findings.api';

interface InquiryFindingsBreadcrumbParams {
  inquiryId?: string;
  investigationId?: string;
}

export const InquiryFindingsBreadcrumb = (params: InquiryFindingsBreadcrumbParams) => {
  const inquiryId = params.inquiryId;
  const { data, isLoading } = useGetInquiryHeaderQuery(inquiryId ?? '', {
    skip: !inquiryId,
  });

  return <BreadcrumbLabel label={data?.inquiryName ?? 'Inquiry Findings'} isLoading={isLoading} />;
};
